import request from '@/utils/request'

// 添加用户
export function addUser(data) {
  return request({
    url: '/person/add',
    method: 'post',
    data
  })
}

// 更新用户
export function updateUser(data) {
  return request({
    url: '/person/update',
    method: 'post',
    data
  })
}

// 删除用户
export function deleteUser(data) {
  return request({
    url: '/person/delete',
    method: 'post',
    data
  })
}

// 分页查询用户列表
export function requestPageList(data) {
  return request({
    url: '/person/page',
    method: 'post',
    data
  })
}

// 禁用用户
export function disableUser(data) {
  return request({
    url: '/person/disable',
    method: 'post',
    data
  })
}

// 启用用户
export function enableUser(data) {
  return request({
    url: '/person/enable',
    method: 'post',
    data
  })
}

// 设置月度积分
export function setMonthPoints(data) {
  return request({
    url: '/person/monthPoints',
    method: 'post',
    data
  })
}

// 教程配置信息
export function requestTutorialUrl(data) {
  return request({
    url: '/setting/tutorial',
    method: 'post',
    data
  })
}
